import { Controller } from "stimulus";
import $ from 'jquery';
import _ from "slick-carousel";

export default class extends Controller {
  connect() {
    const slideToShowMax = this.element.dataset.slideToShowMax ? Number(this.element.dataset.slideToShowMax) : 3;
    const slideToShowMin = this.element.dataset.slideToShowMin ? Number(this.element.dataset.slideToShowMin) : 2;

    $(this.element).slick({
      slidesToShow: slideToShowMax,
      infinite: false,
      nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
      prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: slideToShowMin
          }
        }
      ]
    });
    // ローディング中画面が崩れるのでHTMLでopacity = 0を指定して解除する
    setTimeout(() => {
      this.element.style.opacity = 1;
    }, 300);
  }

  disconnect() {
    $(this.element).slick("unslick");
  }
}
